import {Injectable} from '@angular/core';
import {ModelSchema, Structures} from 'octopus-model';
import {SwitchSettingsType} from 'shared/utils/settings';
import {modulesSettings} from '../../../settings';
import {get} from 'lodash-es';

const RawSettings = {
    addRewardClass: Structures.boolean(false),
    authorizeExitUseOnlyShowNextButtonRules: Structures.boolean(false),
    avatarChoice: Structures.boolean(true),
    defaultActiveTab: Structures.string('accessories'),
    exportAvatar: Structures.boolean(false),
    isOnboardingEnabled: Structures.boolean(false),
    isQuitButtonOnRewardsDialogAlwaysVisible: Structures.boolean(true),
    showRewards: Structures.boolean(false),
    showRewardNavigateToAchievement: Structures.boolean(true)
}
const settingsStructure: ModelSchema = new ModelSchema(RawSettings);

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private readonly privateSettings: SwitchSettingsType<typeof RawSettings>;

    constructor() {
        this.privateSettings = settingsStructure.filterModel(modulesSettings.gamification) as SwitchSettingsType<typeof RawSettings>
    }

    public isAvatarChoiceEnabled() {
        return get(this.privateSettings, 'avatarChoice', false);
    }

    public isShowRewardsEnabled() {
        return get(this.privateSettings, 'showRewards', false);
    }

    public getDefaultActiveTab() {
        return get(this.privateSettings, 'defaultActiveTab', 'accessories');
    }

    public isExportAvatarEnabled() {
        return get(this.privateSettings, 'exportAvatar', false);
    }

    public isOnboardingEnabled() {
        return get(this.privateSettings, 'isOnboardingEnabled', false);
    }

    public getShowRewardNavigateToAchievement() {
        return get(this.privateSettings, 'showRewardNavigateToAchievement', true);
    }

    public getAddRewardClass() {
        return get(this.privateSettings, 'addRewardClass', false);
    }

    public getAuthorizeExitUseOnlyShowNextButtonRules(): boolean {
        return get(this.privateSettings, 'authorizeExitUseOnlyShowNextButtonRules', false);
    }

    public isQuitButtonOnRewardsDialogAlwaysVisible() {
        return get(this.privateSettings, 'isQuitButtonOnRewardsDialogAlwaysVisible', true);
    }
}
